"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnansweredQuestionsWarningWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var PageValidationMessage_1 = require("../helpers/PageValidationMessage");
var UnansweredQuestionsWarningWidget = /** @class */ (function (_super) {
    __extends(UnansweredQuestionsWarningWidget, _super);
    function UnansweredQuestionsWarningWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }
    UnansweredQuestionsWarningWidget.prototype.render = function () {
        var _a, _b, _c;
        var journeyState = this.props.engine.getJourneyState();
        var hideUnansweredWarning = (_a = journeyState["hideUnansweredWarning"]) !== null && _a !== void 0 ? _a : true;
        // If 'hideUnansweredWarning' is not undefined it means entire page validation did happen
        // by pressing "Next" button. We consider it as a trigger to show this warning widget.
        // But we don't want it to be visible(even if there are unanswered questions) until customer
        // did get to the end of the page and clicked Next button.
        if (hideUnansweredWarning) {
            return null;
        }
        var unansweredQuestions = this.getUnansweredQuestions((_c = (_b = this.props.page) === null || _b === void 0 ? void 0 : _b.questions) !== null && _c !== void 0 ? _c : []);
        // all questions are answered, nothing to warn about
        if (unansweredQuestions.length === 0) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(PageValidationMessage_1.PageValidationMessage, { topText: this.getErrorTitle(unansweredQuestions), bottomText: this.getErrorMessage(unansweredQuestions), handleCloseFunction: this.handleClose }));
    };
    UnansweredQuestionsWarningWidget.prototype.getUnansweredQuestions = function (questions) {
        var _a, _b, _c, _d, _e;
        var unansweredQuestions = [];
        var _loop_1 = function (question) {
            // Check if the question is displayed based on the display condition
            var isDisplayed = question.displayCondition === undefined ||
                journey_services_1.ConditionEvaluator.evaluateCondition(this_1.props.journey.displayConditions, question.displayCondition, this_1.props.interaction);
            if (isDisplayed) {
                // Check if the question has an available 'interactionField' and doesn't have an answer
                if (question.interactionField !== undefined) {
                    var questionErrors_1 = (_b = (_a = this_1.props.validations[question.name]) === null || _a === void 0 ? void 0 : _a.errors) !== null && _b !== void 0 ? _b : [];
                    var questionValidationErrors = (_d = (_c = question.validations) === null || _c === void 0 ? void 0 : _c.filter(function (validation) { var _a; return questionErrors_1.includes((_a = validation.errorMessage) !== null && _a !== void 0 ? _a : ""); })) !== null && _d !== void 0 ? _d : [];
                    // Check the first validation error for journeyDecline - because it has the highest priority, and only it will be shown.
                    var questionFailedValidationOnJourneyDecline = questionValidationErrors.length > 0 && ((_e = questionValidationErrors[0].settings) === null || _e === void 0 ? void 0 : _e.journeyDecline);
                    // questionValidationErrors.length + 1 - counts if 'mandatory' check is also failing - it is hard to work with that check since it is hardcoded as part of journey engine implementation
                    if (questionErrors_1.length > 0 && (!questionFailedValidationOnJourneyDecline || questionValidationErrors.length + 1 === questionErrors_1.length)) {
                        //fix for addressLookup widget validation check, it can be excluded as it is not possible to proceed with an empty address anyway
                        if (question.name !== "addressLookup") {
                            unansweredQuestions.push(question.name);
                        }
                    }
                }
                // If the question has sub-questions, recursively process them
                if (question.questions) {
                    var subUnansweredQuestions = this_1.getUnansweredQuestions(question.questions);
                    unansweredQuestions.push.apply(unansweredQuestions, subUnansweredQuestions);
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, questions_1 = questions; _i < questions_1.length; _i++) {
            var question = questions_1[_i];
            _loop_1(question);
        }
        return unansweredQuestions;
    };
    UnansweredQuestionsWarningWidget.prototype.getErrorTitle = function (invalidQuestions) {
        if (invalidQuestions.length > 1) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["There are ", (0, jsx_runtime_1.jsx)("strong", { children: invalidQuestions.length }), " unanswered questions before continue."] }));
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["There is ", (0, jsx_runtime_1.jsx)("strong", { children: invalidQuestions.length }), " unanswered question before continue."] }));
    };
    UnansweredQuestionsWarningWidget.prototype.getErrorMessage = function (invalidQuestions) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "hyperlink", onClick: this.scrollToElement(invalidQuestions[0]), children: "Click here to go to the next one." }) });
    };
    UnansweredQuestionsWarningWidget.prototype.scrollToElement = function (question) {
        return function () {
            var element = document.getElementById(question);
            if (element !== null) {
                var mobile = 200;
                var desktop = 160;
                var scrollOffset = window.innerWidth > 450 ? desktop : mobile;
                scrollTo(0, element.getBoundingClientRect().top + window.scrollY - scrollOffset);
            }
        };
    };
    UnansweredQuestionsWarningWidget.prototype.handleClose = function () {
        var _a;
        this.props.engine.setJourneyState((_a = {}, _a["hideUnansweredWarning"] = true, _a));
    };
    return UnansweredQuestionsWarningWidget;
}(plugin_journey_1.WidgetBase));
exports.UnansweredQuestionsWarningWidget = UnansweredQuestionsWarningWidget;
//# sourceMappingURL=UnansweredQuestionsWarningWidget.js.map